import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as swRegistration from "@/swRegistration";
import { initWebVitals } from "@/services/vitals";

// Fire-and-forget — never blocks render. Reports LCP / INP / CLS to /api/activation/track.
initWebVitals();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker with update callback
swRegistration.register({
  onUpdate: (registration) => {
    // Dispatch custom event so App.js can show the update banner
    window.dispatchEvent(
      new CustomEvent('sw-update', { detail: registration })
    );
  },
});
